import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=30d03414&scoped=true"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProjectDashboard.vue?vue&type=style&index=0&id=30d03414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d03414",
  null
  
)

export default component.exports